import React, { useState, useEffect } from "react";
import useDarkMode from '../../../hooks/useDarkMode';
import Select from "react-select";
import DropDownStyles, { DropDownStylesDark } from "../../../pages/staff/dropdownStyles.js";

const PageSizeDropDownSelection = ({ defaultValue, onChange, className }) => {
  const pageSizeOptions = [
    { value: "20", label: "20" },
    { value: "50", label: "50" },
    { value: "100", label: "100" },
  ];

  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();
  const dropdownStyles = isDarkMode ? DropDownStylesDark : DropDownStyles;

  

  return (
    <div className={className}>
      <Select
        key={`pagesize-${isDarkMode}`}
        defaultValue={defaultValue}
        onChange={onChange}
        options={pageSizeOptions}
        styles={dropdownStyles}
        classNamePrefix="react-select"
        placeholder={"Page Size"}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        menuShouldBlockScroll={false}
        menuShouldScrollIntoView={false}
        closeMenuOnScroll={false}
      />
    </div>
  );
};

export default PageSizeDropDownSelection;

export const SortOrderDropDownSelection = ({ defaultValue, onChange, disableMenuPortal = false }) => {
  const sortOrderOptions = [
    { value: "DESC", label: "Desc" },
    { value: "ASC", label: "Asc" },
  ];

  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();
  const dropdownStyles = isDarkMode ? DropDownStylesDark : DropDownStyles;

  const portalProps = disableMenuPortal
    ? {}
    : {
        menuPortalTarget: document.body,
        menuPosition: "fixed",
      };

  return (
    <Select
      key={`sortorder-${isDarkMode}`}
      defaultValue={defaultValue}
      onChange={onChange}
      options={sortOrderOptions}
      styles={dropdownStyles}
      classNamePrefix="react-select"
      placeholder={"Sort Order"}
      {...portalProps}
      menuShouldBlockScroll={false}
      menuShouldScrollIntoView={false}
      closeMenuOnScroll={false}
    />
  );
};

export const GenderDropDownSelection = ({
  defaultValue,
  onChange,
  selectedValue,
}) => {
  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];

  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();
  const dropdownStyles = isDarkMode ? DropDownStylesDark : DropDownStyles;

  

  return (
    <Select
      key={`gender-${isDarkMode}`}
      defaultValue={defaultValue}
      value={genderOptions.find((option) => option.value === selectedValue)}
      onChange={onChange}
      options={genderOptions}
      styles={dropdownStyles}
      classNamePrefix="react-select"
      placeholder="Select Gender"
      isClearable={true}
      menuPlacement="auto"
      menuPosition="absolute"
      menuShouldBlockScroll={false}
      menuShouldScrollIntoView={false}
      closeMenuOnScroll={false}
    />
  );
};
